import React, { useEffect } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import { encode } from "../utils/queryString";
import { State } from "../store/types";
import { StaffSessionBanner } from "./StaffSessionBanner";

type Props = RouteComponentProps & {
  authenticated: boolean;
  usingStaffSession: boolean;
};

const AuthenticatedOnly: React.FC<Props> = props => {
  useEffect(() => {
    if (!props.authenticated) {
      props.history.push({
        pathname: "/login",
        search: encode({
          returnUrl: [props.location.pathname + props.location.search]
        })
      });
    }
  }, [props.authenticated, props.history, props.location]);

  return (
    <>
      {props.usingStaffSession && <StaffSessionBanner />}
      {props.children}
    </>
  );
};

function mapStateToProps(state: State) {
  return {
    authenticated: state.auth.authenticated,
    usingStaffSession: state.auth.usingStaffSession
  };
}

export default connect(mapStateToProps)(withRouter(AuthenticatedOnly));
